import Vue from "vue";
import {
  Form,
  FormItem,
  Button,
  Input,
  Table,
  TableColumn,
  Pagination,
  Menu,
  MenuItem,
  Submenu,
  Col,
  Row,
  Container,
  Main,
  Aside,
  Message,
  MessageBox,
  Header,
  Breadcrumb,
  BreadcrumbItem,
  Tooltip,
  Card,
  Switch,
  Dialog,
  Select,
  Option,
  Tag,
  Tree,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tabs,
  TabPane,
  Alert,
  Cascader,
  Step,
  Steps,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  RadioButton,
  CheckboxButton,
  Upload,
  Timeline,
  TimelineItem,
  DatePicker,
  Image,
} from "element-ui";
Vue.use(TimelineItem);
Vue.use(Timeline);
Vue.use(Upload);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Alert);
Vue.use(Cascader);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(CheckboxButton);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tree);
Vue.use(Tag);
Vue.use(Select);
Vue.use(Option);
Vue.use(Switch);
Vue.use(Dialog);
Vue.use(Card);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Container);
Vue.use(Row);
Vue.use(Col);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Menu);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(Input);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(DatePicker)
Vue.use(Image)
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
